import { SxProps } from '@mui/material'

interface ConfirmationModalStyles {
  container: SxProps
  headerIconWrapper: SxProps
  headerIcon: SxProps
  actions: {
    wrapper: SxProps
    cancelButton: SxProps
    confirmButton: SxProps
  }
}

export const confirmationModalStyles: ConfirmationModalStyles = {
  container: {
    width: {
      md: 400,
      xs: '100%',
    },
    minHeight: {
      md: 0,
      xs: 325, // we have some space at the bottom for mobile view i.e why we need to give min height
    },
  },
  headerIconWrapper: {
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 3,
    borderWidth: 1,
    borderColor: 'button.borderDisabled',
    borderStyle: 'solid',
    backgroundColor: 'background.default',
  },
  headerIcon: {
    width: 24,
    height: 'auto',
    color: 'button.textSecondary',
  },
  actions: {
    wrapper: {
      display: 'flex',
      gap: 1.5,
      mt: 2,
      flexDirection: { xs: 'column', md: 'row' },
    },
    cancelButton: {
      border: '1px solid',
      borderColor: 'utils.gray300',
    },
    confirmButton: {
      boxShadow: 'none',
    },
  },
}
